import { useEffect, useState } from "react";
import {
  getElapsedSeconds,
  secondsToTimeString,
} from "@circle-react/helpers/dateTimeHelpers/index";

const UPDATE_INTERVAL_MILLISECONDS = 1000;

export const useElapsedTime = strDate => {
  const [elapsedSeconds, setElapsedSeconds] = useState(
    getElapsedSeconds(strDate),
  );

  useEffect(() => {
    const updateInterval = setInterval(() => {
      setElapsedSeconds(getElapsedSeconds(strDate));
    }, UPDATE_INTERVAL_MILLISECONDS);

    return () => clearInterval(updateInterval);
  }, []);

  return secondsToTimeString(elapsedSeconds);
};
